import analyticsService from 'src/helpers/analytics.service';
import { createPandaAnalytics } from 'shared/panda/analytics/panda-analytics';

// Arrow wrapper, not the bare method: analyticsService.track reads `this`, so
// injecting it detached would lose the binding.
export const pandaAnalytics = createPandaAnalytics((event, properties) =>
  analyticsService.track(event, properties),
);
